import { useState } from "react";
import { url } from "../utils/config";
import { toast } from "react-toastify";
import patchData from "../custom_functions/patchData";
import Modal from "../reusable_components/Modal";
import Button from "../reusable_components/Button";
import validateImageDimension from "../custom_functions/validateImageDimension";
import { btnCancel, btnOne, modalContainer, title } from "../utils/style";


function UpdateProfileImage(props) {
    const [ image, setImage ] = useState();
    const [ imageUrl, setImageUrl ] = useState();

    function updateImage(e) {
        const file = e.target.files[0];
        validateImageDimension(
            file, 
            () => {
                toast.error('Image dimension should be between 256x256 and 720x720!', { autoClose: 3000 })
            },
            () => {
                setImage(file);
                setImageUrl(URL.createObjectURL(file))
            }
        );
    }

    function removeImage() {
        setImage(null);
        setImageUrl(null);
    }

    async function update() {
        try {
            if(!image) {
                return toast.error('Please select an Image!', { autoClose: 3000 })
            }
            const formData = new FormData();
            formData.append('image', image);

            patchData(`${url}/profile_image`, formData, (error) => {
                toast.error(error.response.data.message, { autoClose: 3000 });
                props.setShowModal(false)
            }, (data) => {
                toast.success(data.message, { autoClose: 3000 })
                props.setShowModal(false)
            })
        } catch (error) {
            console.log(error)
        }
    }


    return(
        <div className={modalContainer}>
            <div className="bg-white p-4 w-1/3 rounded-lg">
                <div className={title + ' ' + 'text-center'}>UPDATE PROFILE IMAGE</div>
                <div>
                    {
                        !imageUrl ? 
                        <div className="text-center p-4 border border-gray-500 border-dashed">
                            <label 
                                htmlFor="pr-img" 
                                className="text-lg  cursor-pointer text-center"
                            >
                                Select Image
                            </label>
                        </div>
                        :
                        <div className="flex justify-center p-2">
                            <img alt="x" src={imageUrl} width={100} height={100} />
                            <span className="text-black font-bold text-lg -mt-3 cursor-pointer" onClick={() => removeImage()}>x</span>
                        </div>
                    }
                    <input type="file" id="pr-img" className="hidden" accept="image/*" onChange={e => updateImage(e)} />
                    <div className="flex justify-between py-3 px-16 gap-8">
                        <button onClick={e => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                        <Button clickHandler={() => update()} className={btnOne} name={'Submit'} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateProfileImage;